import axios from 'axios';

export const check = async function authServiceCheck () {
  const { data } = await axios.get('/api/auth');

  if (data.data) {
    return data.data;
  }

  return false;
};

export const login = async function authServiceLogin ({ username, password }) {
  const { data } = await axios.post(
    '/api/auth/login',
    { username, password },
  );

  if (data && data.user) {
    return data.user;
  }
};

export const logout = async function authServiceLogout () {
  try {
    await axios.post('/api/auth/logout');

    return true;
  } catch (e) {
    return false;
  }
};

export default {
  check,
  login,
  logout,
};
